import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable()
export class AttendeesGuard implements CanActivate {
  /**
   * @description Constructor
   * @params router
   */
  constructor(private router: Router) {}
  /**
   * @description Can activate
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const experienceId = route.queryParams['id']; 
    if (!experienceId) {
      this.router.navigate(['home-office']);
      return false;
    }
    return true;
  }
}